import {
  GET_VALIDATIONS_SUCCESS,
  GET_VALIDATIONS_FAIL,
  UPDATE_VALIDATION_SUCCESS,
  UPDATE_VALIDATION_FAIL,
  SET_VALIDATION_LOADING,
  CLEAR_VALIDATION_ERROR
} from './types';

const initialState = {
	loading: false,
	report: null,
	validations: [],
	error: null,
};

const validationReducer = function (state = initialState, action) {
	switch (action.type) {
		// this is for fetching loading time setter
		case SET_VALIDATION_LOADING:
			return {
				...state,
				loading: true,
			};

		case CLEAR_VALIDATION_ERROR:
			return {
				...state,
				error: null,
				report: null,
        validations: []
			};

		case GET_VALIDATIONS_SUCCESS:
			return {
				...state,
				reports: action.payload,
				loading: false,
				error: null,
			};

		case UPDATE_VALIDATION_SUCCESS:
			return {
				...state,
				report: action.payload,
				updated: true,
				loading: false,
				validations: state.validations.map((report) => {
					if ((report._id || report.id )=== action.payload._id || action.payload.id) {
						return action.payload;
					} else {
						return report;
					}
				}),
			};

		case GET_VALIDATIONS_FAIL:
		case UPDATE_VALIDATION_FAIL:
			return {
				loading: false,
				error: action.payload,
			};

		default:
			return state;
	}
};

export default validationReducer;
